import {ParamsFetchType, MethodType, GenerateUrlApiType, ResponseType} from 'src_common/browser/apiUtils';
import {GenerateUrlApiParamsType} from 'src_common/server/webDriver/sdkApiWebUtils';

import {decodeBoolean} from 'src/api/utils/commonModelValidators';
import {buildApiItemDefault, buildModelValidator} from 'src/api/utils/modelUtils';

export const decodeAvailabilityRab = buildModelValidator('RAB availability data', {
    offerRab: buildApiItemDefault(decodeBoolean, false)
});

export type AvailabilityRabDataModel = ReturnType<typeof decodeAvailabilityRab>;

const decode = (status: number, data: ResponseType): AvailabilityRabDataModel | null => {
    if (status === 200 && data.type === 'json') {
        return decodeAvailabilityRab(data.json);
    }

    if (status === 404) {
        return null;
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface RabGetAvailabilityParamsType {
    platformId: string
}


// TODO: seems not used anywhere - wait some time before delete
export const rabGetAvailability = {
    browser: {
        params: ({platformId}: RabGetAvailabilityParamsType): ParamsFetchType<RabGetAvailabilityParamsType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/availabilityRab',
                body: {
                    platformId
                }
            };
        },
        decode
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/availabilityRab'
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<RabGetAvailabilityParamsType>): Promise<GenerateUrlApiType> => {
        return {
            url: `${params.API_URL}/rab-api/${params.API_UNIVERSE}/events/${params.req.body.platformId}`,
            passToBackend: true,
            method: MethodType.GET
        };
    }
};
